import { Injectable } from '@angular/core';
import { isBoardItem } from 'src/app/sessions/common/y-session';
import { TelemetryService } from '../../../../services/telemetry.service';
import { YCanvas } from '../../wb-canvas/fabric-utils';
import { ItemModel } from '../../../../models/itemModel';

@Injectable({
  providedIn: 'root',
})
export class BoardItemsLoggingService {
  private renderedWebViewersIds = new Set<string>();
  private canvas?: YCanvas;

  private boundCanvasObjectsListener = this.reportCanvasObjectsCount.bind(this);

  constructor(private telemetry: TelemetryService) {}

  public listenToCanvas(canvas: YCanvas) {
    this.canvas = canvas;
    this.canvas.on('object:added', this.boundCanvasObjectsListener);
    this.canvas.on('object:removed', this.boundCanvasObjectsListener);
  }

  public reportWebViewerDestroyed(itemId: string) {
    this.renderedWebViewersIds.delete(itemId);
    this.sendRenderedWebViewersCountToTelemetry();
  }

  public reportWebViewerRendered(itemId: string) {
    this.renderedWebViewersIds.add(itemId);
    this.sendRenderedWebViewersCountToTelemetry();
  }

  private sendRenderedWebViewersCountToTelemetry() {
    this.telemetry.setSessionVars({
      count_active_webviewers: this.renderedWebViewersIds.size,
    });
  }

  private reportCanvasObjectsCount() {
    if (!this.canvas) {
      return;
    }
    const objects = this.canvas.getObjects();

    const count_board_objects_visible = (objects.filter((o) => o.visible) || []).length;

    let count_pdfs = 0;
    let count_images = 0;
    let count_webviewers = 0;
    let count_iframe_mario_apps = 0;
    objects.forEach((o) => {
      if (!isBoardItem(o)) {
        return;
      }
      count_pdfs =
        count_pdfs + +(o.itemType === ItemModel.PDF) + +(o.itemType === ItemModel.PDFImages);
      count_images = count_images + +(o.itemType === ItemModel.Image);
      count_webviewers = count_webviewers + +(o.itemType === ItemModel.WebViewer);
      count_iframe_mario_apps =
        count_iframe_mario_apps + +[ItemModel.Mario, ItemModel.IFrame].includes(o.itemType);
    });

    // The count here doesn't say anything about the content of the item (web viewer might be destroyed, iframe might be later not rendered.. )
    this.telemetry.setSessionVars({
      count_board_objects_visible,
      count_pdfs,
      count_webviewers,
      count_iframe_mario_apps,
      count_images,
    });
  }

  public destroyService() {
    this.canvas?.off('object:added', this.boundCanvasObjectsListener);
    this.canvas?.off('object:removed', this.boundCanvasObjectsListener);
    this.renderedWebViewersIds.clear();
  }
}
